// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetTECFinanceCompaniesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";

export function getTECFinanceCompaniesDataView(state: ApplicationState, parameter: GetTECFinanceCompaniesApiParameter) {
    return getDataView(state.greif.data.tecFinanceCompanies, parameter);
}
